import { render, staticRenderFns } from "./centeredText.vue?vue&type=template&id=4049ed57"
import script from "./centeredText.vue?vue&type=script&lang=js"
export * from "./centeredText.vue?vue&type=script&lang=js"
import style0 from "./centeredText.vue?vue&type=style&index=0&id=4049ed57&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports